import React from 'react';
import {
  Dimensions,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  useColorScheme,
} from 'react-native';
import {Animated} from 'react-native';
import Svg, {Rect, Defs, Mask} from 'react-native-svg';
import {useTutorial} from '../../../../context/TutorialProvider';

const {width: screenWidth, height: screenHeight} = Dimensions.get('screen');

interface Props {
  highlightX: Animated.Value;
  highlightY: Animated.Value;
  highlightWidth: Animated.Value;
  highlightHeight: Animated.Value;
  borderRadius: number;
  onPress?: () => void; // Função chamada ao pressionar na área destacada
  additionalWidth?: number;
  additionalHeight?: number;
  customY?: number;
  customX?: number;
  skipOnBackpress?: boolean;
}

export const GlobalMask = ({
  highlightX,
  highlightY,
  highlightWidth,
  highlightHeight,
  borderRadius,
  additionalHeight,
  customY,
  customX,
  additionalWidth,
  skipOnBackpress,
  onPress,
}: Props) => {
  const theme = useColorScheme();
  const {setCurrentStep, currentStep} = useTutorial();

  return (
    <View style={StyleSheet.absoluteFill}>
      {/* SVG para criar o fundo escurecido */}
      {skipOnBackpress ? (
        <Svg
          height={screenHeight}
          width={screenWidth}
          style={StyleSheet.absoluteFill}>
          <Defs>
            {/* @ts-ignore */}
            <Mask id="mask" maskUnits="userSpaceOnUse">
              <Rect
                x="0"
                y="0"
                width={screenWidth}
                height={screenHeight}
                fill="white"
              />
              <Rect
                x={
                  customX
                    ? (highlightX as unknown as number) - customX
                    : (highlightX as unknown as number) - 7.5
                }
                y={
                  customY
                    ? (highlightY as unknown as number) - customY
                    : (highlightY as unknown as number) - 5
                }
                width={
                  additionalWidth
                    ? (highlightWidth as unknown as number) + additionalWidth
                    : (highlightWidth as unknown as number) + 15
                }
                height={
                  additionalHeight
                    ? (highlightHeight as unknown as number) + additionalHeight
                    : (highlightHeight as unknown as number) + 10
                }
                rx={borderRadius}
                ry={borderRadius}
                fill="black"
              />
            </Mask>
          </Defs>
          <TouchableWithoutFeedback
            onPress={() => {
              setCurrentStep(currentStep + 1);
              return;
            }}>
            <Rect
              x="0"
              y="0"
              width={screenWidth}
              height={screenHeight}
              fill={
                theme === 'dark'
                  ? 'rgba(255, 255, 255, 0.5)'
                  : 'rgba(0, 0, 0, 0.7)'
              }
              mask="url(#mask)"
            />
          </TouchableWithoutFeedback>
        </Svg>
      ) : (
        <Svg
          height={screenHeight}
          width={screenWidth}
          style={StyleSheet.absoluteFill}>
          <Defs>
            {/* @ts-ignore */}
            <Mask id="mask" maskUnits="userSpaceOnUse">
              <Rect
                x="0"
                y="0"
                width={screenWidth}
                height={screenHeight}
                fill="white"
              />
              <Rect
                x={
                  customX
                    ? (highlightX as unknown as number) - customX
                    : (highlightX as unknown as number) - 7.5
                }
                y={
                  customY
                    ? (highlightY as unknown as number) - customY
                    : (highlightY as unknown as number) - 5
                }
                width={
                  additionalWidth
                    ? (highlightWidth as unknown as number) + additionalWidth
                    : (highlightWidth as unknown as number) + 15
                }
                height={
                  additionalHeight
                    ? (highlightHeight as unknown as number) + additionalHeight
                    : (highlightHeight as unknown as number) + 10
                }
                rx={borderRadius}
                ry={borderRadius}
                fill="black"
              />
            </Mask>
          </Defs>
          <Rect
            x="0"
            y="0"
            width={screenWidth}
            height={screenHeight}
            fill={
              theme === 'dark'
                ? 'rgba(255, 255, 255, 0.5)'
                : 'rgba(0, 0, 0, 0.7)'
            }
            mask="url(#mask)"
          />
        </Svg>
      )}

      {/* Touchable apenas na área destacada */}
      <TouchableWithoutFeedback onPress={onPress} disabled={!onPress}>
        <View
          style={{
            position: 'absolute',
            left: customX
              ? (highlightX as unknown as number) - customX
              : (highlightX as unknown as number) - 7.5,
            top: customY
              ? (highlightY as unknown as number) - customY
              : (highlightY as unknown as number) - 5,
            width: additionalWidth
              ? (highlightWidth as unknown as number) + additionalWidth
              : (highlightWidth as unknown as number) + 15,
            height: additionalHeight
              ? (highlightHeight as unknown as number) + additionalHeight
              : (highlightHeight as unknown as number) + 10,
          }}
        />
      </TouchableWithoutFeedback>
    </View>
  );
};
